import { Form, InputNumber, Typography } from "antd";
import React from "react";

const CaloriesAndProtien = () => {
  return (
    <>
      <Typography>Nutritional Recommendations</Typography>
      <Form.Item
        label="Energy"
        name={["nutritional_recommendations", "calories"]}
      >
        <InputNumber addonAfter="K.cal/day" />
      </Form.Item>
      <Form.Item
        label="Protein"
        name={["nutritional_recommendations", "protein"]}
      >
        <InputNumber addonAfter="gms/day" />
      </Form.Item>
      <Form.Item
        label="Carbohydrates"
        name={["nutritional_recommendations", "carbohydrates"]}
      >
        <InputNumber addonAfter="gms/day" />
      </Form.Item>
      <Form.Item
        label="Sodium"
        name={["nutritional_recommendations", "sodium"]}
      >
        <InputNumber addonAfter="mg/day" />
      </Form.Item>
      <Form.Item
        label="Potassium"
        name={["nutritional_recommendations", "potassium"]}
      >
        <InputNumber addonAfter="mg/day" />
      </Form.Item>
    </>
  );
};

export default CaloriesAndProtien;
